import { registerPlugin } from '@capacitor/core'
import type { AlbumPlugin } from './definitions'

const Album = registerPlugin<AlbumPlugin>('Album')

export * from './definitions'
export { Album }
